





















import { ShareDateTranslator } from "@/infrastructure/folder/translators";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DownloadHistory } from "@/domain/history";
import { DomainRegistry } from "@/domain";

@Component
export default class DownloadFileHistoryView extends Mixins() {
  data() {
    return {
      isLoading: false,
      histories: [] as DownloadHistory[],
    };
  }
  isLoading: boolean;
  histories: DownloadHistory[];

  @Prop()
  folderGuid: string;

  toDateString(date: Date): string {
    const dateTranslator = new ShareDateTranslator();
    return dateTranslator.toDateTimeDispString(date);
  }

  async getDownloadFileHistories(folderGuid: string): Promise<DownloadHistory[]> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.history.getHistoryRepository();
      return await repository.getDownloadHistories(folderGuid);
    } catch (e) {
      this.$error("ダウンロード履歴取得エラー", "ダウンロード履歴一覧の取得中にエラーが発生しました。", e);
    } finally {
      this.isLoading = false;
    }
  }

  @Watch("folderGuid")
  onFolderGuidChanged(newValue: string, oldValue: string): void {
    if (newValue === oldValue) { return; }
    if (!newValue) {
      this.histories = [];
      return;
    }
    this.getDownloadFileHistories(newValue)
      .then(h => this.histories = h);
  }
}
